<mat-expansion-panel class="md-expansion-demo-width" #myPanel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6"><h6>Widget Configuration</h6></div>
      <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <mat-table #table [dataSource]="widgets" matSort>
    <ng-container matColumnDef="widgetname">
      <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>

      <mat-cell *matCellDef="let widget">{{ widget.widgetname }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
      <mat-cell *matCellDef="let widget">{{ widget.description }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="enabled">
      <mat-header-cell *matHeaderCellDef>Enabled</mat-header-cell>
      <mat-cell *matCellDef="let widget">
        <mat-checkbox
          [(ngModel)]="widget.enabled"
          [checked]="widget.enabled"
          #showButtons
        ></mat-checkbox>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let widget; columns: displayedColumns"></mat-row>
  </mat-table>

  <mat-paginator #paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]">
  </mat-paginator>

  <mat-action-row>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
      <button
        (click)="previousStep($event)"
        id="previousbtn"
        bciprimarybutton
        class="button-primary"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      <button
        type="submit"
        bciprimarybutton
        class="button-primary"
        id="submitbtn"
        style="margin-left: 3px"
        (click)="saveWidgetConfig()"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Submit
      </button>

      <button
        (click)="nextStep($event)"
        bciprimarybutton
        class="button-primary"
        id="nextbtn"
        style="margin-left: 3px"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </mat-action-row>
</mat-expansion-panel>
